module.exports = __webpack_public_path__ + "static/img/car_mianbao@3x.c746befc.png";